module.exports = __webpack_public_path__ + "assets/img/fcmy.ce3003fa.png";